<template>
  <v-col cols="12" md="4" sm="12">
    <v-card elevation="0" outlined min-height="490">
      <v-card-title class="mx-2 ">Latest Transaction</v-card-title>
      <v-divider class="mx-2"></v-divider>

      <v-list>
        <template v-for="(item, index) in latestTransactions">
          <v-divider
            v-if="item.divider"
            :key="index"
            :inset="item.inset"
          ></v-divider>

          <v-list-item v-else :key="item._id" class="my-3">
            <v-avatar
              :color="
                item.TransactionMethods === 'Cash'
                  ? '#2E8E46'
                  : item.TransactionMethods === 'Debit Card'
                  ? '#0B3866'
                  : '#8E2E2E'
              "
              size="50"
            >
              <span class="white--text">{{
                item.TransactionMethods === "Debit Card"
                  ? "Debit"
                  : item.TransactionMethods
              }}</span>
            </v-avatar>

            <v-list-item-content class="ml-3">
              <v-list-item-title
                class="font-weight-bold"
                v-html="item.TransactionType"
              ></v-list-item-title>
              <v-list-item-title class="caption">{{
                item.createdAt
              }}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-icon>
              <span
                class="caption"
                >{{ item.TransactionType === "Expense" ? "-" : "" }}${{
                  parseFloat(item.Amount).toFixed(2)
                }}</span
              >
              <v-icon
                class="ml-1"
                :color="
                  item.TransactionType === 'Expense'
                    ? 'red accent-4'
                    : ' green accent-4'
                "
              >
                {{
                  item.TransactionType === "Expense"
                    ? "mdi-arrow-down-bold"
                    : "mdi-arrow-up-bold"
                }}
              </v-icon>
            </v-list-item-icon>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: {
    latestTransactions: {
      type: Array,
    },
  },
  data() {
    return {};
  },
};
</script>
